module.exports = "/images/vendor/flag-icon-css/flags/1x1/lr.svg?6656f943933fa3febede9e123fdfbc73";